<div *ngIf="checkForErrors()" class="invalid-feedback block col-sm-{{ gridSize(offset) }} offset-sm-{{ offset }}">
    <span *ngIf="hasError('required')" translate>This field is required</span>
    <span *ngIf="hasError('minlength')" translate>Too few characters</span>
    <span *ngIf="hasError('maxlength')" translate>Too many characters</span>
    <span *ngIf="hasError('min')" translate>Number too low</span>
    <span *ngIf="hasError('max')" translate>Number too high</span>
    <span *ngIf="hasError('pattern')">{{ patternMsg }}</span>
    <span *ngIf="hasError('email')" translate>Not valid email</span>
    <span *ngIf="hasError('invalidUrl')" translate>Not valid URL</span>
</div>
